export default __webpack_public_path__ + "static/hero-5e2c073205ae6b27a771a834175d9b21.svg";